import React, { useEffect, useState } from "react";
import Editor from "../../../elements/tiptap-editor/Editor.js";
import Select from "../../../form/select/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { postAddEdit } from "../../../../services/postService";
import { useMutation, useQuery } from "@tanstack/react-query";
import Input from "../../../form/Input";
import { toast } from "react-toastify";
import { taxonomyList } from "../../../../services/taxonomyService";
import MultiselectDropdown from "../../../form/MultiselectDropdown";
import FlexibleSelect from "../../../form/select/FlexibleSelect";

const validation = {
  title: { required: true, message: "Question is required" },
  content: { required: true, message: "Answer is required" }
};

const ManageFaq = ({ getResponse = () => {}, close = () => {}, data }) => {
  const [categories, setCategories] = useState([]);
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
      setCategories(data?.categories);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const {
    mutate,
    error,
    isLoading: detailsLoading,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await postAddEdit({
        ...val,
        categories: categories,
        type: "faq",
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { data: categoryData } = useQuery({
    queryKey: ["category"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 10000,
        type: "faq-category",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-4">
          <Input
            label="FAQ Question"
            inputPlaceholder="title"
            onChange={handleChange}
            inputName={"title"}
            required={false}
            value={values?.title}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label={"Answer"}
            height={200}
            value={values?.content}
            placeholder={"Write Something"}
            onChange={(val) =>
              handleChange({
                target: { name: "content", value: val },
              })
            }
            {...formValidate(errors, "content")}
          />
        </div>
        <div className="relative col-span-4">
          {/* <Select
            label={"Category"}
            placeholder={"Select category"}
            onChange={(e) => handleChange({ target: { name: "categories", value: e } })}
            selectedValue={values?.category}
            dropdownData={categoryData?.data?.map((item) => {
              return {
                name: item?.title,
                value: item?._id,
              };
            })}
            {...formValidate(errors, "categories")}
          /> */}

          <FlexibleSelect
            label={"Select category"}
            isSearch={false}
            placeholder={"Select a category"}
            selectedValue={categories}
            onChange={setCategories}
            type="multiple"
            dropdownData={categoryData?.data?.map((item) => {
              return {
                name: item?.title,
                value: item?._id,
              };
            })}
            {...formValidate(errors, "categories")}
          />
        </div>
      </div>
      <div className="pt-3 p-6 flex justify-end">
        <Button
          buttonType="submit"
          buttonClasses={"min-w-36"}
          buttonLabel={data?._id ? "Update" : "Save"}
          {...((isLoading || detailsLoading) && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </form>
  );
};

export default ManageFaq;
